import IconMacroCarbsSvg from "./icons/macro-carbs.svg?react";
import IconMacroFatSvg from "./icons/macro-fat.svg?react";
import IconMacroFiberSvg from "./icons/macro-fiber.svg?react";
import IconMacroProteinSvg from "./icons/macro-protein.svg?react";

export const IconMacroProtein = IconMacroProteinSvg;
export const IconMacroCarbs = IconMacroCarbsSvg;
export const IconMacroFiber = IconMacroFiberSvg;
export const IconMacroFat = IconMacroFatSvg;
